// extracted by mini-css-extract-plugin
export var csatScore = "_n3-5";
export var header = "_n3-1";
export var panelWrapper = "_n3-2";
export var postPreview = "_n3-3";
export var rightContent = "_n3-0";
export var wrappingText = "_n3-4";